/**
 * ✅ RESTAURANT HOOKS INDEX
 * 
 * Restoran moduna özel hook'ları export eder.
 */

export { useRestaurantCartOperations } from './useRestaurantCartOperations';
export type { 
  UseRestaurantCartOperationsParams, 
  UseRestaurantCartOperationsReturn 
} from './useRestaurantCartOperations';

export { useRestaurantKitchenOperations } from './useRestaurantKitchenOperations';
export type { 
  UseRestaurantKitchenOperationsParams, 
  UseRestaurantKitchenOperationsReturn 
} from './useRestaurantKitchenOperations';

export { useRestaurantTableOperations } from './useRestaurantTableOperations';
export type { 
  UseRestaurantTableOperationsParams, 
  UseRestaurantTableOperationsReturn 
} from './useRestaurantTableOperations';

export { useRestaurantNumpadOperations } from './useRestaurantNumpadOperations';
export type { 
  UseRestaurantNumpadOperationsParams, 
  UseRestaurantNumpadOperationsReturn 
} from './useRestaurantNumpadOperations';
